import { parseHostBindings } from '@angular/compiler';
import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[appLeadOfferActionAcceptIcon]',
    standalone: false
})
export class LeadOfferActionAcceptIconDirective {

  @HostBinding('style') style = 'color: green; margin-left: 0.5rem; cursor: pointer; transform: scale(1.25);'
  @HostBinding('innerHTML') iconType = 'check_circle'

  constructor() { }

}
